import React, { PropsWithChildren } from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const SectionWrapper = ({ classProps, children }: PropsWithChildren & PropsWithClassProps) => {
  return <div className={twMerge('mx-auto max-w-md', classProps?.root)}>{children}</div>;
};
